import { useState, useEffect, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../styles/Header.css';
import logoS from '../assets/images/LogoNoBG3.png';
import logoSub from '../assets/images/logo_sub.png';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    const handleResize = () => {
      if (window.innerWidth > 1080) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const closeMenu = () => {
    setTimeout(()=> setIsMobileMenuOpen(false), 130)
  }

  const scrollToAbout = useCallback((e) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      sessionStorage.setItem('navIntent', JSON.stringify({ type: 'about' }));
      navigate('/');
      return;
    }
    const intro = document.getElementById('intro');
    if (!intro) return;
    // About card lives at ~35% of the Intro ScrollTrigger range (+=1000%)
    const scrollTop = intro.offsetTop + window.innerHeight * 10 * 0.35;
    window.scrollTo({ top: scrollTop, behavior: 'smooth' });
  }, [location.pathname, navigate]);

  const openDesktopApp = useCallback((appId, e) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      sessionStorage.setItem('navIntent', JSON.stringify({ type: 'openApp', appId }));
      navigate('/');
      return;
    }
    const docEl = document.documentElement;
    const maxScroll = Math.max(0, docEl.scrollHeight - window.innerHeight);
    window.scrollTo({ top: maxScroll, behavior: 'auto' });
    setTimeout(() => {
      if (window.__desktopOpenWindow) window.__desktopOpenWindow(appId);
    }, 300);
  }, [location.pathname, navigate]);

  return (
    <>
      <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
        <div className="brand-container">
          <a href='/'><img src={logoS} alt="Logo" className="logo"/></a>
          {/* <span className="brand-name">Your Brand</span> */}
          <img src={logoSub} alt="Logo" className="logo-name" />
        </div>

        <nav className="nav-menu">
          <a href="/#intro" className="nav-link" onClick={scrollToAbout}>About</a>
          <a href="#desktop" className="nav-link" onClick={(e) => openDesktopApp('projects', e)}>Projects</a>
          <a href="#desktop" className="nav-link" onClick={(e) => openDesktopApp('experience', e)}>Experience</a>
          <a href="#desktop" className="nav-link" onClick={(e) => openDesktopApp('contact', e)}>Contact</a>
          <a href="#desktop" className="nav-link" onClick={(e) => openDesktopApp('blog', e)}>Blogs</a>
        </nav>

        <button 
          className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle navigation menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </header>

      <div className={`mobile-menu ${isMobileMenuOpen ? 'active' : ''}`}>
        <nav className="mobile-nav">
          <a href="/#intro" onClick={(e) => { scrollToAbout(e); closeMenu(); }} className="nav-link">About</a>
          <a href="#desktop" className="nav-link" onClick={(e) => { openDesktopApp('projects', e); closeMenu(); }}>Projects</a>
          <a href="#desktop" className="nav-link" onClick={(e) => { openDesktopApp('experience', e); closeMenu(); }}>Experience</a>
          <a href="#desktop" className="nav-link" onClick={(e) => { openDesktopApp('contact', e); closeMenu(); }}>Contact</a>
          <a href="#desktop" className="nav-link" onClick={(e) => { openDesktopApp('blog', e); closeMenu(); }}>Blogs</a>
        </nav>
      </div>
    </>
  );
};

export default Header;